import MedicationsScreen from "app/screens/pendingSignOffs/MedicationsScreen";

export default function MedicationsPage() {
  return <MedicationsScreen />;
}
